import React, { Component } from 'react'
import { Row, Col, Input, Form, Icon, Checkbox, Button, Card } from 'antd'
import { login } from './auth';

import './Login.css'
import SiteIcon from './components/SiteIcon';

const FormItem = Form.Item;

class NormalLoginForm extends Component {
    // handleSubmit = (e) => {
    //     e.preventDefault();
    //     this.props.form.validateFields((err, values) => {
    //       if (!err) {
    //         console.log('Received values of form: ', values);
    //       }
    //     });
    // }

    state = { loginMessage: null }

    setErrorMsg(error) {
        return {
          loginMessage: error
        }
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                login(values.userName, values.password)
                .then(x => {
                    this.setErrorMsg(x)
                    console.log("Logged in successfully!");
                    console.log(x);
                })
                .catch((error) => {
                    this.setState(this.setErrorMsg('Invalid username/password.'))
                });
            }
          });
        }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
          <Form onSubmit={this.handleSubmit} className="login-form">
            <FormItem>
              {getFieldDecorator('userName', {
                rules: [{ required: true, message: 'Please input your username!' }],
              })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Please input your Password!' }],
              })(
                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
              )}
            </FormItem>
            <FormItem>
              {/* <a className="login-form-forgot" href="">Forgot password</a> */}
              <Button type="primary" htmlType="submit" className="login-form-button">
                Log in
              </Button>
              {/* Or <a href="">register now!</a> */}
            </FormItem>
            {this.state.loginMessage}
          </Form>
        );
      }
}
        
const WrappedNormalLoginForm = Form.create()(NormalLoginForm);

export default class Login extends Component {
    state = { cardSpan: 6 }

    render() {
        return(
            <Row className='login__row'>
                <Col xs={{ span: 18, offset: 2}} sm={{ span: 16, offset: 4}} md={{ span: 14, offset: 5}} lg={{ span: 10, offset: 7}} xl={{ span: 8, offset: 8}} >
                    <Card title={
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <SiteIcon/><h2>Visual Produce Content Center</h2>
                        </div>
                    }>
                        <WrappedNormalLoginForm/>
                    </Card>
                </Col>
            </Row>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Login.js